export default __webpack_public_path__ + "static/media/changeCalories.e37e63e9.svg";